// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

window.textParallaxAnimation = function textParallaxAnimation() {
  let tl = gsap.timeline();
  const scrollingText = document.querySelectorAll('[data-text-parallax]');
  if (scrollingText.length >= 1) {
    let speed = 20;

    if (window.innerWidth <= 768) {
      speed = 15;
    }

    scrollingText.forEach((text, i) => {
      let val;
      if (!text.hasAttribute('data-text-parallax-revert')) {
        val = speed;
      } else {
        val = -speed;
      }

      if (ScrollTrigger.isTouch !== 1) {
        tl.to(text, {
          xPercent: val,
          scrollTrigger: {
            trigger: text,
            scrub: 0,
          },
        });
      } else {
        text.removeAttribute('data-text-parallax');
        if (text.hasAttribute('data-text-parallax-revert')) {
          text.removeAttribute('data-text-parallax-revert');
          text.setAttribute('data-view', 'fade-r');
        } else {
          text.setAttribute('data-view', 'fade-l');
        }
        text.parentElement.classList.add('optimize-animation');
      }
    });
  }
};

if (!document.querySelector('.bold-loader-new')) {
  textParallaxAnimation();
}
